<template>
    <v-card>
        <v-card-title class="modified">Changes to {{ thingSchema.displayName }} Schema</v-card-title>
        <v-card-text>
            <v-row v-if="schemaChanges.propertyDifferences.length > 0">
                <v-col cols="12">
                    <h3>Changes to Schema Properties</h3>
                    <li v-for="propertyDifference of schemaChanges.propertyDifferences">
                        <pre>{{ propertyDifference.property }}</pre> was changed from
                        <pre>{{ getDisplayChangedValue(propertyDifference.originalValue) }}</pre> to
                        <pre>{{ getDisplayChangedValue(propertyDifference.modifiedValue) }}</pre>
                    </li>
                </v-col>
            </v-row>
            <v-row v-if="schemaChanges.attributeDifferences.oneTimeAttributeDifferences.length > 0">
                <v-col cols="12">
                    <h3>Changes to One-Time Attributes</h3>
                </v-col>
                <v-col cols="12">
                    <AttributeChanges :attribute-differences="schemaChanges.attributeDifferences.oneTimeAttributeDifferences"/>
                </v-col>
            </v-row>
            <v-row v-if="schemaChanges.attributeDifferences. timeSeriesAttributeDifferences.length > 0">
                <v-col cols="12">
                    <h3>Changes to Time-Series Attributes</h3>
                </v-col>
                <v-col cols="12">
                    <AttributeChanges :attribute-differences="schemaChanges.attributeDifferences.timeSeriesAttributeDifferences"/>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer/>
            <v-btn @click="close" color="primary">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script setup lang="ts">

import { ThingSchemaAdminConfig } from "@/services/schemas/manageSchemasAPI";
import { getDisplayChangedValue, SchemaChanges } from "@/lib/schemaUtils";
import AttributeChanges from "@/components/SchemaConfig/AttributeChanges.vue";

const {
    thingSchema,
    schemaChanges
} = defineProps<{
    thingSchema: ThingSchemaAdminConfig,
    schemaChanges: SchemaChanges
}>();

const emit = defineEmits<{
    (e: "close");
}>()

function close() {
    emit("close");
}

</script>
<style scoped>
pre {
    display: inline-block;
    background-color: #e0e0e0;
}
</style>
